export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class SumupTotalAll {
  curriculum_id: number
  examinee_count: number
  allot: number
  avg_score: string
  std_dev: string
  min_score: number
  max_score: number

  constructor(sumupTotalAll: any){
    this.curriculum_id = sumupTotalAll.curriculum_id;
    this.examinee_count = sumupTotalAll.examinee_count;
    this.allot = sumupTotalAll.allot;
    this.avg_score = sumupTotalAll.avg_score.toFixed(1);
    this.std_dev = sumupTotalAll.std_dev.toFixed(1);
    this.min_score = sumupTotalAll.min_score;
    this.max_score = sumupTotalAll.max_score;
  }
}

export class SumupBunpu {
  curriculum_id: number
  score_from: number
  score_to: number
  examinee_count: number
  percent: number

  constructor(sumupBunpu: any){
    this.curriculum_id = sumupBunpu.curriculum_id;
    this.score_from = sumupBunpu.score_from;
    this.score_to = sumupBunpu.score_to;
    this.examinee_count = sumupBunpu.examinee_count;
    this.percent = sumupBunpu.percent;
  }
}

export class BunpuResult {
  no: number
  sumupBunpus: SumupBunpu[]
  cols: any[] = new Array<any>()
  colKinds: ColKindEnum[] = new Array<ColKindEnum>()

  constructor(sumupBunpus: any){
    this.sumupBunpus = sumupBunpus.map((x: any) => new SumupBunpu(x));
    this.sumupBunpus.forEach(x => {
      this.cols.push(`${x.score_to}点<br>～<br>${x.score_from}点`);
      this.cols.push(`${x.examinee_count}名`);
      this.cols.push(x.percent);

      this.colKinds.push(ColKindEnum.ScoreRange);
      this.colKinds.push(ColKindEnum.Count);
      this.colKinds.push(ColKindEnum.ScoreRate);
    })
  }
}

export enum ColKindEnum{
  ScoreRange = 1,
  Count = 2,
  ScoreRate = 3
};